import React, { useContext, useState, useEffect } from 'react'
import { BOOKING_PRE_PAYMENT, BOOKING_STATUS } from '../../constants'
import { FaChevronUp } from 'react-icons/fa'
import { withOrientationChange, isTablet, isMobileOnly } from 'react-device-detect'
import { Context } from '../../Store'
import RatingBanner from '../ratingBanner'
import NextStepBanner from '../nextStepBanner'
import { isBookingR2R } from '../booking'
import { getFeatureFlagCheckout2025 } from '../../components/Checkout_Page_2025/Forms/LegacyValidations'

export const getPricing = (property, booking, hasCounteroffer) => {
  const { consumptionCosts = 0 } = property
  const { extra_fee, prop } = booking
  const isBookingPending = booking.status === BOOKING_STATUS.PENDING
  const price = hasCounteroffer ? booking.counter_offer : isBookingPending ? booking.tenant_proposal : property.price
  const monthly = hasCounteroffer
    ? booking.counter_offer
    : parseFloat(prop?.tari || 0) + parseFloat(price) + parseFloat(consumptionCosts || 0)
  const monthlyMinusPrePayment = monthly - BOOKING_PRE_PAYMENT
  const upfrontFee = extra_fee

  const deposit = isBookingR2R(booking)
    ? price * booking.deposit
    : (price - (booking?.property_total_cost || 0) - (booking?.monthly_fee || 0)) * booking.deposit
  return { price, monthly, monthlyMinusPrePayment, upfrontFee, deposit }
}

const NewPriceFlow = (props) => {
  const [state] = useContext(Context)
  const deviceMobile = isMobileOnly || (isTablet && props.isPortrait)
  const [open, setOpen] = useState(!deviceMobile)

  useEffect(() => {
    setOpen(!deviceMobile)
  }, [deviceMobile])

  const isNewCheckout2025Enabled = getFeatureFlagCheckout2025()
  if (isNewCheckout2025Enabled) return <></>

  return (
    <>
      {deviceMobile && (
        <div className="flex flex-col items-center justify-center w-full" onClick={() => setOpen(!open)}>
          <FaChevronUp style={open && { transform: 'rotate(180deg)' }} />
          {!open && (
            <div
              className="bg-white"
              style={{
                paddingTop: '1rem',
                paddingLeft: '0.9375rem',
                paddingRight: '0.9375rem',
                borderRadius: '1.5rem 1.5rem 0 0',
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                display: 'flex',
              }}
            >
              <RatingBanner {...props} />
            </div>
          )}
          {open && (
            <div
              className="bg-white flex flex-col justify-between items-center w-full overflow-auto"
              style={{
                paddingTop: '1rem',
                paddingLeft: '0.9375rem',
                paddingRight: '0.9375rem',
                borderRadius: '1.5rem 1.5rem 0 0',
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                height: 'calc(100vh - 5.875rem)',
              }}
            >
              <>
                <RatingBanner {...props} />
                <NextStepBanner hasPrePayment={state.booking.has_pre_payment} {...props} />
              </>
            </div>
          )}
        </div>
      )}
      {!deviceMobile && (
        <>
          <RatingBanner {...props} />
          <NextStepBanner hasPrePayment={state.booking.has_pre_payment} {...props} />
        </>
      )}
    </>
  )
}

export default withOrientationChange(NewPriceFlow)
